import CandidateAddPage from './add/'

export default {
  CandidateAddPage
}
